import React, { FunctionComponent, useState, useEffect } from "react";
import { Typography } from "@material-ui/core";
import "./index.scss";
import { Space } from "services/entities/spaces";
import vector from "../../assets/img/map/vector.svg";
import { useHistory, generatePath } from "react-router";
import RouteURLs from "RouteURLs";
import EmblaCarousel from "components/EmblaCarousel";
import { LazyLoadImage } from "react-lazy-load-image-component";

type SpaceTileProps = {
  space: Space;
  variant?: string;
};

export const SpaceTile: FunctionComponent<SpaceTileProps> = ({
  space,
  variant,
}) => {
  const history = useHistory();
  const [isDraggable, setIsDraggable] = useState(false);

  useEffect(() => {
    const updateDraggable = () => {
      if (window.innerWidth <= 1024) {
        setIsDraggable(true);
      } else {
        setIsDraggable(false);
      }
    };
    updateDraggable();
    window.addEventListener("resize", updateDraggable);
    return () => window.removeEventListener("resize", updateDraggable);
  }, []);

  const getSpacePage = () => {
    history.push(generatePath(RouteURLs.VIEW_SPACE, { slug: space.code }));
  };

  const topFiveImages =
    space.images.length > 5 ? space.images.slice(0, 5) : space.images;

  return (
    <div
      className={`component--space-tile ${variant && variant}`}
      key={space.code}
      onClick={() => getSpacePage()}
    >
      <div className="details">
        <Typography variant="body1" component="p" className="title">
          {space.shortDescription}
        </Typography>
        <span className="location">
          <img src={`${vector}`} alt="map marker" className="vector" />
          <Typography variant="body1" component="p">
            {space.shortAddress}
          </Typography>
        </span>
      </div>
      <div className="space-image-slider">
        <EmblaCarousel
          loop={true}
          draggable={isDraggable}
          hasDots={true}
          largeNavArrows={false}
          hasThumbs={false}
          align={0}
        >
          {topFiveImages.map((image, i) => {
            return (
              <div className="slide-wrapper" key={i}>
                <LazyLoadImage
                  src={image.url}
                  effect="blur"
                  width="100%"
                  height="100%"
                  alt="image of sook"
                />
                <div className="price">
                  <p className="price-text">
                    from <br /> <span>£{space.samplePrice?.amount}</span> a day
                  </p>
                </div>
              </div>
            );
          })}
        </EmblaCarousel>
      </div>
    </div>
  );
};

export default SpaceTile;
